module.exports = __webpack_public_path__ + "img/active_passive.14b3dae6.png";